import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { DatePicker } from "rsuite";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import CharacterAuthorizeIcon from "@rsuite/icons/CharacterAuthorize";
import ArowBackIcon from '@rsuite/icons/ArowBack';

import {
 
  updateCliente,
updateCNHCliente
} from "../../store/modules/cliente/actions";

export default function CadastroCnhClient() {

  const dispatch = useDispatch();
  const {  cliente, auth, users_licenses , form} = useSelector(
    (state) => state.cliente);
    let navigate = useNavigate();


 async function validaCampos() {
   
      let schema = yup.object().shape({
        number: yup
          .string("Erro: Necessário preencher o campo Cnh")
          .required("Erro: Necessário preencher o campo Cnh"),
        photo : yup
          .string("Erro: Falta a  foto  da Cnh")
          .required("Erro: Falta a  foto  da Cnh"),
          category: yup
          .string("Erro: Necessário preencher o campo categoria").max(2)
          .required("Erro: Necessário preencher o campo categoria"),     
          valid_to: yup
         .date("Erro: Necessário preencher o campo validade").required()
      })


      try {
        await schema.validate(users_licenses);
        dispatch(
          updateCliente({
            form: { ...form, type: "success", messageError: "success" },
          })
        );
        return true;
      } catch (error) {
        dispatch(
          updateCliente({
            form: { ...form, type: "error", messageError: error.errors },
          })
        );
        return false;
      }
    }

 
      const cadastrarCnh = async (event) => {
 
    
  if (!(await validaCampos())) return;

     dispatch(updateCNHCliente())
       
   
        dispatch(
          updateCliente({
            form: { ...form, result : false },
          }))
        navigate("/reserva")
       
      };

      const voltar = ()=>{
        navigate("/reserva")
      }
      const setCliente = (key, value) => {
        dispatch(
          updateCliente({
            users_licenses: { ...users_licenses, [key]: value },
          })
        );
      };
     

    return (
    <div className="bg-black d-flex flex-column  justify-content-center">
      <div className="d-flex flex-column text-center  col-12 text-white ">
      {form.type === "success" ? (
            <div className="alert alert-success" role="alert">
              {form.messageError}
            </div>
          ) : (
            ""
          )}
          {form.type === "error" ? (
            <div className="alert alert-danger" role="alert">
              {form.messageError}
            </div>
          ) : (
            ""
          )}
        <h3>Cadastro de CNH</h3>
       
        <div className="m-3" >
          <div className="form-group col-12 mt-2 text-white ">
            <b className="">Numero cnh</b>
            <input
            name="number"
              type="text"
              id="number"
              className="form-control mt-2 text-center"
              placeholder="cnh"
               value={users_licenses.number}
              onChange={(e) =>
             setCliente("number", e.target.value)
             }
            />
          </div>
          <div className="d-flex flex-column  text-white mt-1 ">
            <b>Validade</b>
            <DatePicker
             id="valid_to"
             name="valid_to"
              className="mt-1"
              ranges={[
                {
                  label: "today",
                  value: new Date(),
                },
              ]}
              format="dd-MM-yyyy"
              calendarDefaultDate={new Date()}
              color="orange"
              style={{ width: "auto" }}
             
              onChange={(e) => {
               setCliente("valid_to", e);
              }}
            />
          </div>
          <div className="form-group col-12 mt-2 text-white ">
            <b className="">Categoria</b>
            <input
               id="category"
            name="category"
              type="text"
              className="form-control mt-2 text-center"
              placeholder="Categoria"
              value={users_licenses.category}
             onChange={(e) =>
               setCliente("category", e.target.value)
             }
            />
          </div>
              <div className="btn btn-outline-success d-flex flex-column mt-3">
              <b>Foto </b>
              <input name="photo"  id="photo"type="file" accept="image/png, image/gif, image/jpeg" capture="camera"   multiple={true}   onChange={(e) => { 
               
               
               setCliente("photo", e.target.files[0]);
              }}/>   
        
          </div>


        </div>
        <div className=" d-flex m-3 justify-content-between  ">
          <div>

          <button onClick={cadastrarCnh} className="btn btn-outline-success">
            Cadastrar
            <CharacterAuthorizeIcon className="" />
          </button>
          </div>
          <div>

          <button className="btn btn-outline-success " onClick={voltar}>
            Voltar
            <ArowBackIcon className="" />
          </button>
          </div>
        </div>
      </div>
    </div>
  );
}
